export default __webpack_public_path__ + "static/chainlink-logo-7b2704fb25637a288f3fd4c8bcd6cddd.svg";